module.exports = ".modal-open {\n  /* 100% = dialog height, 120px = header + footer */\n  max-height: calc(100% - 120px);\n  overflow-y: scroll; }\n\n.modal-dialog,\n.modal-content {\n  /* 80% of window height */\n  height: 80%; }\n\n.brand {\n  -ms-flex-line-pack: rigth;\n      align-content: rigth; }\n\n.align-buttons {\n  text-align: right; }\n\nimg {\n  display: block;\n  max-width: 100%;\n  max-height: 200px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-create-slider/master-create-slider.component.scss
// module id = ./src/app/master/master-create-slider/master-create-slider.component.scss
// module chunks = main